import { NewRepository, Repository } from "./repository";
const customerRepo = {
  sendSms,
  getCustomerInfo,
  changeAddress
};
const resource = "Customer";

function sendSms(payLoad) {
  
  return Repository().post(`${resource}/sendSmsCode/`, payLoad);
}
function getCustomerInfo(mobile) {
  return Repository().get(`${resource}/item?mobile=${mobile}`);
}
function changeAddress(payLoad,token) {
  //return Repository(token).post(`${resource}/changeAddress/`, payLoad);
  return NewRepository(`${resource}/changeAddress`,payLoad,token)
}
export default customerRepo